module.exports = __webpack_public_path__ + "img/赛迪LOGO.dfdec0df.png";